<template>
  <div class="components-attTypeBatchModify">
    <van-nav-bar title="批量修改" left-arrow @click-left="exit_batchModel" />
    <div class="main">
      <div class="toolbox">
        <van-checkbox
          v-model="checkedAll"
          @click="selectedAll"
          :style="{ visibility: display_filter ? 'hidden' : 'visible' }"
          >全选</van-checkbox
        >
        <a @click="display_filter = !display_filter" href="javascript:;" class="attFilter-btn fr"
          >{{ selected_typeItem.name }}<img :src="require('@/assets/attendance/more@2x.png')"
        /></a>
      </div>
      <ul class="list" v-show="current_studentList.length > 0">
        <li
          class="student"
          v-for="(item, index) in current_studentList"
          :key="index"
          @click="toggle_selected(item, index)"
        >
          <van-checkbox v-model="item.selected">
            <Avatar :iconPath="item.Icon" :fullName="item.FullName" class="avatar"></Avatar>
            <div class="fullName">{{ item.FullName }}</div>
          </van-checkbox>
        </li>
      </ul>
      <div v-show="current_studentList.length === 0" class="list xy-phone-no-data">
        <img src="@/assets/common/moblie-no-data.png" />
        <p style="font-size:16px">暂无数据</p>
      </div>
    </div>
    <div class="footer">
      <div class="btn plain" @click="exit_batchModel">取消</div>
      <div class="btn" @click="set_attType">去处理</div>
    </div>
    <div class="typeListFilter-wrapper" v-show="display_filter">
      <van-picker
        :columns="typeList_forFilter"
        @change="change_filter"
        :default-index="selected_typeItem.index"
      />
      <div class="typeListFilter-footer">
        <a href="javascript:;" class="attFilter-btn-pop" @click="cancel_attTypeFilter">取消</a>
        <a href="javascript:;" class="attFilter-btn-pop primary" @click="confirm_attTypeFilter"
          >确定</a
        >
      </div>
    </div>
    <van-popup v-model="display_popWindow" position="bottom">
      <ModifyStatus
        v-if="display_typeList"
        nameKey="AttTypeName"
        :typeList="typeList"
        @cancel="hide_typeList"
        @confirm="confirm_typeList"
        @closed="display_typeList = false"
      ></ModifyStatus>
    </van-popup>
  </div>
</template>

<script>
import ModifyStatus from '@/pages/attendance/components/ModifyStatus.vue'
import Avatar from '@/pages/attendance/components/Avatar.vue'
export default {
  name: 'Components_AttTypeBatchModify',
  components: {
    ModifyStatus,
    Avatar
  },
  props: {
    studentListIncoming: {
      required: true,
      type: Array,
      default: function() {
        return []
      }
    },
    typeList: {
      required: true,
      type: Array,
      default: function() {
        return []
      }
    },
    classID: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      /* [Start]展示用的数据 */
      // 类型列表
      current_attType: {
        AttTypeID: 6,
        AttTypeName: '暂未考勤',
        Ratio: 0.0,
        AttCode: 'Notyet',
        AttTypeNum: 0,
        AttTypeColumnName: 'Column6'
      },
      typeList_full: [],
      typeList_forFilter: [],
      // 类型筛选：Vant Picker 的当前选择情况（尚未点击“确定按钮进行确认”）
      filter_current: {
        item: {},
        index: 0, // 当前游标的筛选下标
        value: '' // 当前游标的筛选值
      },
      // 类型筛选：Vant Picker 的筛选结果（已经点击“确定按钮进行确认”）
      selected_typeItem: {
        value: {},
        index: 0, // 筛选下标
        name: '' // 筛选值名称
      },
      // 学生列表
      selected_students: [],
      studentList_all: [],
      current_studentList: [],
      /* [End]展示用的数据 */

      /* [Start]状态控制 */
      display_filter: false,
      display_popWindow: false,
      display_typeList: false,
      lockWindow_storage: {},
      checkedAll: true
      /* [End]状态控制 */
    }
  },
  computed: {},
  methods: {
    // 初始化完整的学生列表，得出当前选择的学生列表
    deepClone_studentList() {
      let all = JSON.parse(JSON.stringify(this.studentListIncoming))
      this.$set(this, 'studentList_all', all)
      // 默认选择 暂未考勤
      //  this.filter_studentList(this.selected_typeItem.item.TypeID)
      // 暂未考勤数据不显示的问题
      this.filter_studentList(this.selected_typeItem.item.AttTypeID)
    },
    // 设置为筛选的学生列表
    filter_studentList(TypeID) {
      let all = JSON.parse(JSON.stringify(this.studentListIncoming))
      this.current_studentList = []
      // 若为全部：
      if (TypeID === -1) {
        this.current_studentList = all
        this.current_studentList.forEach(item => {
          item.selected = true
        })
        return
      }
      all.forEach(item => {
        if (item.TypeID === TypeID) {
          item.selected = true
          this.current_studentList.push(item)
        }
      })
    },
    // 考勤类型设置
    set_attType() {
      let list = this.current_studentList
        .map(item => {
          if (item.selected) {
            return item.StudentID
          }
        })
        .filter(item => item)
      if (list.length === 0) {
        this.xy.msgInfo('请至少选择一位学生')
        return
      }
      this.current_studentIDs = list
      this.display_popWindow = true
      this.display_typeList = true
    },
    // 退出批量编辑模式
    /*
     * refresh: 退出后，是否执行刷新
     */
    exit_batchModel(refresh = false) {
      if (typeof refresh === 'object') {
        refresh = false
      }
      this.unlockWindow()
      this.$emit('exit', refresh)
    },
    // 批量修改视图中，点击了取消
    hide_typeList() {
      this.display_popWindow = false
    },
    // 批量修改视图中，确认了要修改的内容
    confirm_typeList(value) {
      this.save_batchList(value.AttTypeID, this.current_studentIDs)
    },
    async save_batchList(attTypeID, studentIDs) {
      const params = {
        baseID: this.classID,
        typeID: attTypeID,
        studentIDs: studentIDs
      }
      const res = await this.xyapi.post(
        this.$store.state.apiPath + '/api/AttsLesson/SetStudentAttendanceState',
        params
      )
      if (res.success) {
        this.xy.msgSuc('修改成功！')
      } else {
        this.xy.msgError(res.msg)
      }
      this.hide_typeList()
      this.exit_batchModel(true)
    },
    // 切换选择
    toggle_selected(item, index) {
      item.selected = !item.selected
      this.$set(this.current_studentList, index, item)
      this.checkedAll = this.current_studentList.every(item => item.selected)
    },
    // 全选
    selectedAll() {
      this.current_studentList.forEach((item, index) => {
        item.selected = this.checkedAll
        this.$set(this.current_studentList, index, item)
      })
    },
    // 完整的类型列表
    expand_typeList() {
      var list = JSON.parse(JSON.stringify(this.typeList))
      list.unshift({
        AttTypeID: -1,
        AttTypeName: '全部'
      })
      this.$set(this, 'typeList_full', list)
      this.typeList_forFilter = this.typeList_full
        .map(item => item.AttTypeName)
        .filter(item => item)
      // 默认筛选类型
      this.typeList_full.forEach((item, index) => {
        if (item.AttCode === 'Notyet') {
          this.selected_typeItem.index = index
          this.selected_typeItem.name = item.AttTypeName
          this.selected_typeItem.item = item
        }
      })
    },
    // 筛选界面：点击取消按钮
    cancel_attTypeFilter() {
      this.display_filter = false
    },
    // 调整列表筛选
    change_filter(vm, value, index) {
      this.filter_current.index = index
      this.filter_current.value = value
    },
    // 筛选界面：点击确定按钮
    confirm_attTypeFilter() {
      // 查找当前选择的考勤类型项目
      let item = this.typeList_full[this.filter_current.index]
      this.filter_studentList(item.AttTypeID)
      this.selected_typeItem.item = item
      this.selected_typeItem.index = this.filter_current.index
      this.selected_typeItem.name = this.filter_current.value
      this.cancel_attTypeFilter()
    },
    lockWindow() {
      this.lockWindow_storage = {
        html: document.querySelector('html').style.overflow,
        body: document.querySelector('body').style.overflow
      }
      document.querySelector('html').style.overflow = 'hidden'
      document.querySelector('body').style.overflow = 'hidden'
    },
    unlockWindow() {
      let d = this.lockWindow_storage
      document.querySelector('html').style.overflow = d.html
      document.querySelector('body').style.overflow = d.body
    }
  },
  created: function() {
    // 防止用户误将下面层级的内容进行滚动
    this.lockWindow()
    // 注意：由于deepClone_studentList依赖于expand_typeList计算的selected_typeItem.index，故注意执行顺序
    this.expand_typeList()
    this.deepClone_studentList()
  },
  beforeDestroy() {
    this.unlockWindow()
  }
}
</script>

<style lang="less" scoped>
// 颜色方案定义
@color-main-bg: #4196ff;
@color-main-text: #fff;

@color-primary-bg: #4196ff;
@color-primary-text: #fff;
@color-normal-bg: #e9e9e9;
@color-normal-text: #161616;

// 为方便后续的CSS计算，重置vant的导航高度
::v-deep .van-nav-bar {
  height: 5.65vh;
  line-height: 5.65vh;
}

.main {
  margin-top: 16px;
}
.toolbox {
  display: flex;
  justify-content: space-between;
  height: 88px;
  padding: 18px 32px;
  margin-bottom: 2px;
  background: #fff;
}
.list {
  height: calc(
    100vh - 5.65vh - 16px - 91px - 110px
  ); // 总 - vant-nav重置的高度 - main - toolbox - footer
  overflow-y: auto;
}
// 解决Safari浏览器不显示数据问题
ul.list>li:last-child{
  margin-bottom:200px;
}
.student {
  padding: 17px 32px;
  background: #fff;
  margin-top: 1px;
}
.fullName {
  display: inline-block;
  margin-left: 30px;
}
.footer {
  position: fixed;
  z-index: 15;
  bottom: 0;
  width: 100%;
  height: 110px;
  text-align: center;
  padding: 17px 0;
  border-top: 1px solid #cccccc;
  background: #fff;
  .btn {
    margin: 0 10px;
  }
}
.btn {
  display: inline-block;
  line-height: 76px;
  min-width: 270px;
  text-align: center;
  padding: 0 20px;
  background: @color-main-bg;
  color: @color-main-text;
  border: 1px solid @color-main-bg;
  border-radius: 38px;
  &.plain {
    background: #fff;
    color: @color-main-bg;
    border: 1px solid;
  }
  &.small {
    min-width: 126px;
    line-height: 52px;
    border-radius: 26px;
  }
}
.attFilter-btn {
  margin-top: 15px;
  img {
    width: 21px;
    height: 21px;
    margin-left: 20px;
  }
  &-pop {
    display: inline-block;
    width: 50%;
    text-align: center;
    line-height: 88px;
    font-size: 28px;
    background-color: @color-normal-bg;
    color: @color-normal-text;
    &.primary {
      background-color: @color-primary-bg;
      color: @color-primary-text;
    }
  }
}
.checkStatus {
  margin-top: 12px;
  font-size: 40px;
}
.typeListFilter {
  &-wrapper {
    position: fixed;
    z-index: 20;
    top: calc(5.65vh + 16px + 88px); // vant-nav的重置高度 + main的边距16px + .toolbox;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  &-footer {
    background: #fff;
  }
}
</style>
